import React from 'react'
import { Field } from 'formik'
import { IconSparkles } from '@tabler/icons-react'

import { Checkbox } from '@/components/forms/formik'
import { Pill } from '@/components/pills/Pill'

export const AiToggle = ({ name, label, description, checked, disabled, onChange, children }) => {
  return (
    <div className="playbook-config-container playbook-config-container--magical animated-gradient-border">
      <div className="playbook-config-container__content">
        <div className="flex-align-center flex-space-between gap mb">
          <div className="flex-column">
            <div className="label">
              <span className="flex-align-center small-gap">
                <IconSparkles className="icon-svg status-magical" />
                {label}
                <Pill magical xs>
                  New Feature
                </Pill>
              </span>
            </div>
            <div>{description}</div>
          </div>
          <Field
            name={name}
            component={Checkbox}
            toggle
            inline
            reverse
            disabled={disabled}
            checked={checked}
            onChange={onChange}
          />
        </div>
        {checked && children}
      </div>
    </div>
  )
}
